/**
 * 红娘外联请求接口
 * @author 王振宇
 * @since 2026-09-04
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    /**
     * 分页查询红娘外联列表
     */
    GET_MATCHMAKEROUTERLINK_PAGE_LIST: function GET_MATCHMAKEROUTERLINK_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerOuterLink/getPageList',
        method: 'post',
        data: data
      });
    },
    /**
     * 保存(新增) 红娘外联
     */
    SAVE_MATCHMAKEROUTERLINK: function SAVE_MATCHMAKEROUTERLINK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerOuterLink/save',
        method: 'post',
        data: data
      });
    },
    /**
     * 修改(更新) 红娘外联
     */
    UPDATE_MATCHMAKEROUTERLINK: function UPDATE_MATCHMAKEROUTERLINK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerOuterLink/update',
        method: 'put',
        data: data
      });
    },
    /**
     * 修改排序
     */
    UPDATE_SORT_MATCHMAKEROUTERLINK: function UPDATE_SORT_MATCHMAKEROUTERLINK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerOuterLink/updateSort',
        method: 'put',
        data: data
      });
    },
    /**
     * 修改显示状态(隐藏/恢复显示)
     */
    UPDATE_HIDDEN_MATCHMAKEROUTERLINK: function UPDATE_HIDDEN_MATCHMAKEROUTERLINK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerOuterLink/updateHidden',
        method: 'put',
        data: data
      });
    }
  };
});